<template>
  <v-dialog
    max-width="600px"
    persistent
    value="true"
  >
    <v-card>
      <v-toolbar
        dense
        flat
      >
        Edit Rich Text
      </v-toolbar>
			<v-card-text>
				<v-text-field
					v-if="number"
					v-model="editnumber"
					label="Number"
				/>
				<Editor
					ref="htmlEditor"
					:html="html"
				/>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn
					flat
					@click="$emit('cancel')"
				>
					Cancel
				</v-btn>
				<v-btn
					color="info"
					@click="$emit('save')"
				>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Editor from '@/components/admin/Editor'

export default {
  props: [ 'number', 'html' ],
  components: {
    Editor
  },
  data () {
    return {
      editnumber: this.number
    }
  },
  methods: {
    getHTML () {
      return this.$refs.htmlEditor.getHTML()
    },
    getNumber () {
      return this.editnumber
    }
  }
}
</script>
